import { breakpoints } from '../../../../constants'
import { injectGlobal } from 'styled-components'

injectGlobal`	
	.fixed-float-button-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: fixed;
		z-index: 999;
		bottom: 2rem;
		right: 2rem;
		width: auto;
		height: auto;
		
		button {
			border: none;
			cursor: pointer;
			background: none;
			transition: all 0.3s ease;
			padding: 0;
			width: 175px;
			margin-top: 10px;
			
			@media screen and (max-width: ${breakpoints.MEDIUM_SCREEN}px) {
				width: 150px;
			}
			
			&:hover img {
				transform: scale(1.1);
			}
			
			img {
				width: 100%;
				height: 100%;
				transition: transform 0.3s ease;
				box-shadow: 0 4px 12px rgba(158, 158, 158, 0.4);
				border-radius: 15px;
				
				&:hover {
					box-shadow: 0 4px 12px rgba(158, 158, 158, 0.4);
					transform: translateY(-2px);
				}
			}
		}
	}
`
